import { render, staticRenderFns } from "./private-import-lots-ip-report.vue?vue&type=template&id=5216d4f7&scoped=true&"
import script from "./private-import-lots-ip-report.vue?vue&type=script&lang=js&"
export * from "./private-import-lots-ip-report.vue?vue&type=script&lang=js&"
import style0 from "./private-import-lots-ip-report.vue?vue&type=style&index=0&id=5216d4f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216d4f7",
  null
  
)

export default component.exports